import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import JobDashboardActions from '../../dashboards/job/actions';
import JobHistoryOperationActions from '../../operations/job_history/actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchRejectionOperations({ rejectionOperationsParams }) {
  try {
    yield put(Actions.setRejectionOperationsLoaderStatus({ rejectionOperationsLoader: true }));
    const { data } = yield call(api.get, {
      route: 'rejection/getsearched',
      params: rejectionOperationsParams,
    });
    const rejectionOperationsData = data;
    yield put(Actions.setRejectionOperations({ rejectionOperationsData }));
    yield put(Actions.setRejectionOperationsLoaderStatus({ rejectionOperationsLoader: false }));
  } catch (err) {
    yield put(Actions.setRejectionOperationsLoaderStatus({ rejectionOperationsLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchShiftRejection({ shiftRejectionParams }) {
  try {
    yield put(Actions.setRejectionOperationsLoaderStatus({ productionOperationsLoader: true }));
    const { data } = yield call(api.get, {
      route: 'rejection/getshiftRejection',
      params: shiftRejectionParams,
    });
    const shiftRejectionData = data;
    yield put(Actions.setShiftRejection({ shiftRejectionData }));
    yield put(Actions.setRejectionOperationsLoaderStatus({ productionOperationsLoader: false }));
  } catch (err) {
    yield put(Actions.setRejectionOperationsLoaderStatus({ productionOperationsLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}
function* fetchOeesDates({ rejectionParams }) {
  try {
    yield put(Actions.setRejectionOperationsLoaderStatus({ rejectionOperationsLoader: true }));
    const { data } = yield call(api.get, {
      route:
        'rejection/LastFifteenDaysOEES/' +
        rejectionParams.factoryId +
        '/' +
        rejectionParams.equipmentId +
        '/' +
        rejectionParams.jobId,
    });
    const rejectionData = data;
    yield put(Actions.setOeesDates({ rejectionData }));
    yield put(Actions.setRejectionOperationsLoaderStatus({ rejectionOperationsLoader: false }));
  } catch (err) {
    yield put(Actions.setRejectionOperationsLoaderStatus({ rejectionOperationsLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchOeesHours({ rejectionHoursParams }) {
  try {
    yield put(Actions.setRejectionOperationsLoaderStatus({ rejectionOperationsLoader: true }));
    const { data } = yield call(api.get, {
      route:
        'rejection/OEEShiftHours/' +
        rejectionHoursParams.factoryId +
        '/' +
        rejectionHoursParams.equipmentId +
        '/' +
        rejectionHoursParams.equipmentShiftId +
        '/' +
        rejectionHoursParams.jobId,
    });
    const rejectionHoursData = data;
    yield put(Actions.setOeesHours({ rejectionHoursData }));
    yield put(Actions.setRejectionOperationsLoaderStatus({ rejectionOperationsLoader: false }));
  } catch (err) {
    yield put(Actions.setRejectionOperationsLoaderStatus({ rejectionOperationsLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchOeesShifts({ rejectionShiftsParams }) {
  try {
    yield put(Actions.setRejectionOperationsLoaderStatus({ rejectionOperationsLoader: true }));
    const { data } = yield call(api.get, {
      route:
        'rejection/FactoryEquipmentOeeShifts/' +
        rejectionShiftsParams.factoryId +
        '/' +
        rejectionShiftsParams.equipmentId +
        '/' +
        rejectionShiftsParams.date +
        '/' +
        rejectionShiftsParams.jobId,
    });
    const rejectionShiftsData = data;
    yield put(Actions.setOeesShifts({ rejectionShiftsData }));
    yield put(Actions.setRejectionOperationsLoaderStatus({ rejectionOperationsLoader: false }));
  } catch (err) {
    yield put(Actions.setRejectionOperationsLoaderStatus({ rejectionOperationsLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addUpdateRejectionOperation({ actionName, rejectionOperationObj, rejectionOperationsParams }) {
  if (rejectionOperationObj) {
    try {
      yield put(Actions.setRejectionOperationsLoaderStatus({ rejectionOperationsLoader: true }));
      yield call(actionName === CONSTANT_VARIABLES.UPDATE ? api.put : api.post, {
        route: `rejection`,
        data: rejectionOperationObj,
      });
      yield put(Actions.fetchRejectionOperations({ rejectionOperationsParams }));

      if (actionName === CONSTANT_VARIABLES.ADD) {
        yield put(
          Actions.setJobRejectionConfirmationModaldData({
            JobRejectionConfirmationModaldData: rejectionOperationObj.jobName,
          })
        );
      } else {
        notification('success', CONSTANT_VARIABLES.REJECTION_UPDATED, '');
      }
    } catch (err) {
      yield put(Actions.setRejectionOperationsLoaderStatus({ rejectionOperationsLoader: false }));
      notification('error', err.details.response.data ? err.details.response.data : err, '');
      console.warn(err); // Handle exception
    }
  } else {
    notification('error', 'Something went wrong. Please try again!', '');
    console.warn('rejectionOperationObj was null.');
  }
}

function* deleteRejectionOperation({ rejectionId, rejectionOperationsParams }) {
  try {
    yield put(Actions.setRejectionOperationsLoaderStatus({ rejectionOperationsLoader: true }));
    yield call(api.delete, {
      route: `rejection/${rejectionId}`,
    });
    yield put(Actions.fetchRejectionOperations({ rejectionOperationsParams }));
    notification('success', CONSTANT_VARIABLES.REJECTION_DELETED, '');
  } catch (err) {
    yield put(Actions.setRejectionOperationsLoaderStatus({ rejectionOperationsLoader: false }));
    console.warn(err); // Handle exception
  }
}

function* addJobRejection({ rejectionData, jobGridParams }) {
  try {
    yield put(Actions.setRejectionOperationsLoaderStatus({ rejectionOperationsLoader: true }));
    yield call(api.post, {
      route: 'rejection',
      data: rejectionData,
    });
    yield put(JobDashboardActions.setLoader({ showLoader: true }));
    yield put(JobDashboardActions.fetchJobGrid({ jobGridParams }));
    yield put(Actions.setRejectionOperationsLoaderStatus({ rejectionOperationsLoader: false }));
    yield put(
      Actions.setJobRejectionConfirmationModaldData({ JobRejectionConfirmationModaldData: rejectionData.jobName })
    );
  } catch (error) {
    yield put(JobDashboardActions.setLoader({ showLoader: false }));
    yield put(Actions.setRejectionOperationsLoaderStatus({ rejectionOperationsLoader: false }));
    notification(
      'info',
      `The job start date: ${rejectionData.jobFirstStarted} is outside the selected date and shift. Select the correct date and shift`,
      ''
    );
    console.warn(error);
  }
}

function* addJobHistoryRejection({ rejectionData, jobHistoryOperationParams }) {
  try {
    yield put(JobHistoryOperationActions.setJobHistoryOperationLoaderStatus({ jobHistoryOperationLoader: true }));
    yield call(api.post, {
      route: 'rejection',
      data: rejectionData,
    });
    yield put(JobHistoryOperationActions.fetchJobHistoryOperation({ jobHistoryOperationParams }));
    notification('success', CONSTANT_VARIABLES.JOB_REJECTION_ADDED, '');
  } catch (error) {
    yield put(JobHistoryOperationActions.setJobHistoryOperationLoaderStatus({ jobHistoryOperationLoader: false }));
    notification('error', error.details.response.data ? error.details.response.data : error, '');
    console.warn(error);
  }
}

function* addJobHistoryProduction({ productionData, jobHistoryOperationParams }) {
  try {
    yield put(JobHistoryOperationActions.setJobHistoryOperationLoaderStatus({ jobHistoryOperationLoader: true }));
    yield call(api.post, {
      route: 'production',
      data: productionData,
    });
    yield put(JobHistoryOperationActions.fetchJobHistoryOperation({ jobHistoryOperationParams }));
    notification('success', CONSTANT_VARIABLES.JOB_PRODUCTION_ADDED, '');
  } catch (error) {
    yield put(JobHistoryOperationActions.setJobHistoryOperationLoaderStatus({ jobHistoryOperationLoader: false }));
    notification('error', error.details.response.data ? error.details.response.data : error, '');
    console.warn(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_REJECTION_OPERATIONS, fetchRejectionOperations),
    takeLatest(ActionTypes.FETCH_SHIFT_REJECTION, fetchShiftRejection),
    takeLatest(ActionTypes.FETCH_OEE_DATES, fetchOeesDates),
    takeLatest(ActionTypes.FETCH_OEE_HOURS, fetchOeesHours),
    takeLatest(ActionTypes.FETCH_OEE_SHIFTS, fetchOeesShifts),
    takeLatest(ActionTypes.ADD_UPDATE_REJECTION_OPERATION, addUpdateRejectionOperation),
    takeLatest(ActionTypes.DELETE_REJECTION_OPERATION, deleteRejectionOperation),
    takeLatest(ActionTypes.ADD_JOB_REJECTION, addJobRejection),
    takeLatest(ActionTypes.ADD_JOB_HISTORY_REJECTION, addJobHistoryRejection),
    takeLatest(ActionTypes.ADD_JOB_HISTORY_PRODUCTION, addJobHistoryProduction),
  ]);
}
